const IMG_BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/08c57fac-ef4a-4d7c-b99c-1dd88765c6de/';

// Example pages from Volum 1.
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    src: `${IMG_BASE}1792558662919_gk-v1-p05-2294b89b.webp`,
    label: 'Årsplan · Side 5',
    title: 'Årsplan 1.–2. trinn',
    text: 'En ferdig årsplan for 1.–2. trinn – så du alltid vet hva neste time skal handle om.'
  },
  {
    src: `${IMG_BASE}1792558667544_gk-v1-p12-9066d0cf.webp`,
    label: 'Ferdig time · Side 12',
    title: 'Time 1 minutt for minutt: «Dyrene i skogen»',
    text: 'En komplett time minutt for minutt med oppvarming, hoveddel og avslutning.'
  },
  {
    src: `${IMG_BASE}1792558671175_gk-v1-p13-30a926cf.webp`,
    label: 'Timekort · Side 13',
    title: 'Timekort til utskrift',
    text: 'Hele timen på ett kort: aktiviteter, tider og instrukser å ta med inn i gymsalen.'
  },
  {
    src: `${IMG_BASE}1792558675053_gk-v1-p36-a6caf277.webp`,
    label: 'Ferdighetstest · Side 36',
    title: 'Ferdighetstest 1.–4. trinn',
    text: 'Enkle tester med tydelige kriterier som viser hvor eleven står og hva som er neste steg.'
  },
  {
    src: `${IMG_BASE}1792558678182_gk-v1-p39-ed3f8f21.webp`,
    label: 'Vurdering · Side 39',
    title: 'Vurderingsmatrise + 10 ferdige kommentarer',
    text: 'Vurderingsmatrise med kjennetegn på måloppnåelse og ferdige lærerkommentarer du kan bruke direkte.'
  }
];
